(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  document.querySelectorAll('#topbar .topbar-copy-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var coupon = btn.getAttribute('data-coupon');
      if (!coupon) return;

      navigator.clipboard.writeText(coupon).then(function() {
        btn.classList.add('is-copied');

        var msg = document.createElement('span');
        msg.className = 'topbar-copied-msg';
        msg.innerHTML = '<svg viewBox="0 0 16 16"><polyline points="3.5 8.5 6.5 11.5 12.5 4.5"></polyline></svg> COPIADO!';
        btn.insertAdjacentElement('afterend', msg);

        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            msg.classList.add('is-visible');
          });
        });

        setTimeout(function() {
          msg.classList.remove('is-visible');
          btn.classList.remove('is-copied');
          setTimeout(function() { msg.remove(); }, 300);
        }, 2500);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
